import React from 'react';
import { Button } from '../common/Button/Button';
import '../../App.css';
import './HeroSection.css';
import { useNavigate } from 'react-router-dom';

function HeroSection({ }) {
    const navigate = useNavigate(); // Initialize navigate

    // Default hero data if none is provided
    const heroData = {
        title: 'FOMEJE',
        subtitle: 'What are you waiting for?',
        backgroundImage: '/images/default-hero.jpg' // Fallback image
    };

    return (
        <div className='hero-container'>
            <img 
                src={heroData.backgroundImage} // Use prop for image source
                alt='Hero background' 
                className='hero-background' 
            />
            <h1 className='hero-title'>{heroData.title}</h1>
            <p>{heroData.subtitle}</p>
            <div className='hero-btns'>
                <Button
                    className='btns'
                    buttonStyle='btn--outline'
                    buttonSize='btn--large'
                    // send to sign in
                    onClick={() => {
                        navigate('/sign-in');
                    }}
                >
                    GET STARTED
                </Button>
            </div>
        </div>
    );
}

export default HeroSection;